import { apiClient } from './client'
import type { ApiResponse } from '@/types/api'

export interface LcOperationalResetBlocker {
  code: string
  count: number
}

export interface LcOperationalResetPreview {
  organizationId: number
  centerName: string
  counts: Record<string, number>
  total: number
  blockers: LcOperationalResetBlocker[]
  preserved: string[]
}

export interface LcOperationalResetResult {
  success: boolean
  deletedCounts: Record<string, number>
  totalDeleted: number
  remaining: LcOperationalResetPreview
}

function requireData<T>(response: { data: ApiResponse<T> }, message: string): T {
  if (response.data.data === undefined || response.data.data === null) throw new Error(message)
  return response.data.data
}

export const lcOperationalResetAdminApi = {
  preview: async (organizationId: number) =>
    requireData(
      await apiClient.post<ApiResponse<LcOperationalResetPreview>>(
        `/admin/organizations/${organizationId}/lc-operational-reset/preview`,
      ),
      'Failed to preview LC operational reset',
    ),
  reset: async (organizationId: number, confirmation: string, reason: string) =>
    requireData(
      await apiClient.post<ApiResponse<LcOperationalResetResult>>(
        `/admin/organizations/${organizationId}/lc-operational-reset`,
        { confirmation, reason },
      ),
      'Failed to reset LC operational data',
    ),
}
